(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('systemInfoModalController', systemInfoModalController);

    function systemInfoModalController($uibModalInstance) {
        var vm = this;

        vm.close = function () {
            $uibModalInstance.close();
        }
    }
})();
